//�s��n�J�̸�T
const state = {
  UserName: null, //�W��
  Account: null, //�b��
};
const mutations = {
  SetUserName(state, name) {
    state.UserName = name;
  },
  SetAccount(state, account) {
    state.Account = account;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
